export * from './dictionary';
//# sourceMappingURL=index.js.map